import {
  getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags,
  getGetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Data = GetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags200;

type IUseGetClientAdminsPartnerFeatureFlags = ((args: {
  threeLetterCode: string;
  suspense?: true;
}) => { data: Data }) &
  ((args: { threeLetterCode: string; suspense: false }) => {
    data: Data | undefined;
    isLoading: boolean;
  });

/**
 * パートナーの機能フラグを取得するカスタムフック
 *
 * `suspense` の指定で戻り値の型が変わる:
 * - `suspense: true`（デフォルト）: Suspense 境界内で使用する呼び出し元向け。
 *   data は必ず存在するため `isLoading` は返さない。
 * - `suspense: false`: Suspense 境界を用意できない呼び出し元向け。取得完了まで
 *   data は undefined になり、取得状態は `isLoading` で判定する。
 */
export const useGetClientAdminsPartnerFeatureFlags: IUseGetClientAdminsPartnerFeatureFlags = ({
  threeLetterCode,
  suspense = true,
}: {
  threeLetterCode: string;
  suspense?: boolean;
}) => {
  const { data, isLoading } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlagsKey(threeLetterCode),
    () => getApiV1ThreeLetterCodeClientAdminsPartnerFeatureFlags(threeLetterCode),
    { suspense }
  );

  return { data, isLoading };
};
